import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=8958c97e"
import script from "./Article.vue?vue&type=script&lang=tsx"
export * from "./Article.vue?vue&type=script&lang=tsx"
import style0 from "./Article.vue?vue&type=style&index=0&id=8958c97e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports